<style lang="scss" src="./index.scss"></style>

<template>
  <div
    :class="{
      'wgt-headline': true,
      'padded': value.padded
    }"
  >
    <div v-if="value.title || value.subtitle" class="wgt-hd">
      <span class="title">{{ value.title }}</span>
      <span class="sub-title">{{ `{  ${value.subtitle}  }` }}</span>
      <el-button v-if="value.button.hasBT" style="float: right" size="mini">{{
        value.button.btText || '按钮'
      }}</el-button>
    </div>
    <div :class="value.dot ? 'carousela' : ''">
      <!-- 挂件自定义部分 -->
      <el-carousel height="180px" :autoplay="false" indicator-position="outside" arrow="never">
        <el-carousel-item
          v-for="carouselItem in value.data.length % 10 === 0
            ? value.data.length / 10
            : parseInt(value.data.length / 10) + 1"
          :key="carouselItem"
        >
          <div v-for="bdItem in 2" :key="carouselItem + '-' + bdItem" class="wgt-bd">
            <div
              v-for="(item, index) in value.data"
              :key="`nav-item__${index}`"
              :style="{
                flex:
                  index + 1 <= (carouselItem - 1) * 10 + bdItem * 5 &&
                  index + 1 > (carouselItem - 1) * 10 + (bdItem - 1) * 5 &&
                  index + 1 > (carouselItem - 1) * 10
                    ? 1
                    : 0
              }"
            >
              <div
                v-if="
                  index + 1 <= (carouselItem - 1) * 10 + bdItem * 5 &&
                  index + 1 > (carouselItem - 1) * 10 + (bdItem - 1) * 5 &&
                  index + 1 > (carouselItem - 1) * 10
                "
                class="nav-item"
              >
                <div class="nav-image">
                  <SpImage :src="item.imgUrl" :circle="8" />
                </div>
                <div v-if="item.content" class="nav-item--content">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import config from './config'
export default {
  name: 'WgtJnGridCarousel',
  wgtName: '分页导航',
  wgtDesc: '',
  wgtIcon: 'wgt-jn-grid-carousel',
  config: config,
  props: {
    pageNum: {
      type: Number,
      default: 2
    },
    value: [Object, Array]
  },
  computed: {}
}
</script>
